import _extends from "@babel/runtime/helpers/extends";
import { merge, mapValues, forEach } from "../utils/lodash";
import { initial, format, setLocaleToInstance } from "../utils/StringFomat";
import { getCurrentLang, getRandomKey, convertPandaI18nFormatToLocalResource, setCookieLang, warn, debugInfo, formatLang, error, getOSLang, setCookieKey } from "../utils";
import { DEFAULT_LOCAL_KEY, PANDA_I18N_PACK, PANDA_EXUI } from "../const";
import { pandaEvent, setConfig } from "../services";
var I18n = /*#__PURE__*/function () {
  function I18n(params) {
    var _this = this;
    /**
     * 用组件自持有翻译初始化stringformat实例
     * @param {object} locale 组件自持有翻译
     * @param {string} defaultLang 自定义语种
     */
    this.locale = {};
    /** 当前实例的实际语种 */
    this.currentLang = '';
    /** $i18n组件名（组件独有） */
    this.componentName = '';
    /** $i18n组件包名 (组件独有) */
    this.packageName = '';
    /** 标识 */
    this.type = void 0;
    /** $i18n实例名 */
    this.name = void 0;
    /** 自定义的语种，设置后该实例语种不再受环境语种影响 */
    this.customLang = void 0;
    /** 设置Panda全局配置 */
    this.setConfig = setConfig;
    this.componentName = (params === null || params === void 0 ? void 0 : params.componentName) || '';
    this.type = params === null || params === void 0 ? void 0 : params.type;
    this.packageName = (params === null || params === void 0 ? void 0 : params.packageName) || '';
    // 当前如果用了packageName方案则使用默认实例的name做后缀，后续多packageName的实例将覆盖
    this.name = this.componentName ? this.componentName + "." + (this.packageName && params !== null && params !== void 0 && params.name ? params.name : getRandomKey()) : getRandomKey();
    // 当指定了lang之后该实例将锁定lang，不再受环境和事件影响
    if (params !== null && params !== void 0 && params.lang) {
      this.customLang = params.lang;
    }
    if (params !== null && params !== void 0 && params.locale && this.componentName) {
      // 组件可能传递是会多一层nameSpace，需要脱离，如果是组件不需要合并cdn的文案
      // TLocalResource | TLocalResourceWithNs => TLocalResource
      this.locale = mapValues(params.locale, function (_langLocale) {
        return (_langLocale === null || _langLocale === void 0 ? void 0 : _langLocale[_this.componentName]) || _langLocale || '';
      });
      // 合并语言包文案
      if (window[PANDA_EXUI]) {
        Object.keys(window[PANDA_EXUI]).forEach(function (lang) {
          if (window[PANDA_EXUI] && window[PANDA_EXUI][lang][_this.componentName]) {
            _this.locale[lang] = merge(_this.locale[lang] || {}, window[PANDA_EXUI][lang][_this.componentName]);
          }
        });
      }
    } else {
      this.locale = merge({}, convertPandaI18nFormatToLocalResource(window[PANDA_I18N_PACK]), (params === null || params === void 0 ? void 0 : params.locale) || {});
      setCookieKey();
    }
    this.currentLang = (params === null || params === void 0 ? void 0 : params.lang) || getCurrentLang();
    pandaEvent.on('CHANGE_LANG', function (lang) {
      if (!_this.customLang) {
        _this.currentLang = lang;
      }
    });
    // lang只记录强制lang，环境lang跟随环境走
    initial(this.locale, {
      name: this.name,
      lang: this.customLang,
      packageName: this.packageName,
      $i18n: this
    });
  }
  var _proto = I18n.prototype;
  _proto.init = function init(params) {
    // 如果原实例被记入一个type/packageName，由此新生成的实例也将被打入同一个type/packageName
    return new I18n(_extends({}, params, {
      packageName: (params === null || params === void 0 ? void 0 : params.packageName) || this.packageName,
      type: (params === null || params === void 0 ? void 0 : params.type) || this.type,
      name: this.name
    }));
  }

  /**
   * change current language
   * @deprecated 之后将逐步废弃此方法
   */;
  _proto.change = function change(langTag) {
    warn('Legacy api! Please use $i18n.setLang instead!');
    this.setLang(langTag);
  }

  /**
   * change current language
   * @param {string} langTag language tag
   */;
  _proto.setLang = function setLang(langTag) {
    // 由于后续的文案消费依赖标准的format，故设置需要做处理
    var standardLang = formatLang(langTag);
    if (standardLang !== langTag) {
      error(langTag + " is not a valid language tag, panda converts to " + standardLang + " instead\uFF0Cplease check usage.");
    }
    // set cookie, 由于使用中依然 后端可能存在依然使用老的规范，故设置cookie依然使用用户设置的值
    setCookieLang(langTag);
    // set window
    this.currentLang = standardLang;
    window.__PANDA.lang = standardLang;
    // 为了确保环境变量的一致性，需要将localStorage的值也更新
    if (window.__PANDA.localLang) {
      window.__PANDA.localLang = standardLang;
    }
    // set localStorage
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(DEFAULT_LOCAL_KEY, standardLang);
    }
    debugInfo('Set lang to ' + standardLang);
    pandaEvent.emit('CHANGE_LANG', standardLang);
  }

  /** get current language */;
  _proto.getLang = function getLang() {
    return this.currentLang;
  }

  /** Format string by key */;
  _proto.get = function get(keyValue, variable) {
    var _keyValue$id;
    var isKeyValueString = typeof keyValue === 'string';
    var id = isKeyValueString ? keyValue === null || keyValue === void 0 ? void 0 : keyValue.trim() : (_keyValue$id = keyValue.id) === null || _keyValue$id === void 0 ? void 0 : _keyValue$id.trim();
    var defaultMessage = isKeyValueString ? keyValue : keyValue.dm;
    // namespace 当前只针对组件名
    var nameSpace = isKeyValueString ? this.componentName : keyValue.ns || this.componentName;
    // 指定语种
    var lang = !isKeyValueString && keyValue.lang ? keyValue.lang : this.currentLang;
    var pure = isKeyValueString ? false : !!(keyValue !== null && keyValue !== void 0 && keyValue.pure);
    return format({
      id: id,
      defaultMessage: defaultMessage
    }, variable || null, {
      name: this.name,
      type: this.type,
      nameSpace: nameSpace,
      lang: lang,
      pure: pure
    });
  }

  /** 在当前$i18n实例中添加翻译文案 */;
  _proto.addLocale = function addLocale(locale) {
    this.locale = merge(this.locale, locale);
    setLocaleToInstance(this.locale, this.name);
  }

  /**
   * 在当前$i18n实例中替换locale文案, 可指定自定义组件名来标识实例来源
   * !!!请确保该使用的组件不会以npm的包的形式提供给其他项目使用，否则会造成实例冲突
   * @param locale
   * @param packageName 包名（插件工程建议projectName）
   */;
  _proto.setLocale = function setLocale(locale, packageName) {
    this.locale = locale;
    this.packageName = packageName || getRandomKey();
    setLocaleToInstance(this.locale, this.name);
  }

  /** 在当前$i18n实例增量添加翻译文案 */;
  _proto.addLocaleByKey = function addLocaleByKey(locale) {
    var _this2 = this;
    forEach(locale, function (langLocale, key) {
      forEach(langLocale, function (value, lang) {
        _this2.locale[lang] = _this2.locale[lang] || {};
        _this2.locale[lang][key] = value;
      });
    });
    setLocaleToInstance(this.locale, this.name);
  }

  /** 重新加载语言包资源到当前$i18n实例 */;
  _proto.reloadPackLocale = function reloadPackLocale() {
    this.addLocale(convertPandaI18nFormatToLocalResource(window[PANDA_I18N_PACK]));
  }

  /** 设置该实例的自定义的lang (Pay attention to usage) */;
  _proto.setCustomLang = function setCustomLang(lang) {
    this.currentLang = lang;
    this.customLang = lang;
  }

  /** 根据key返回翻译列表 */;
  _proto.getLocaleByKey = function getLocaleByKey(key) {
    var myLocale = {};
    forEach(this.locale, function (locale, lang) {
      myLocale[lang] = locale[key] || '';
    });
    return myLocale;
  }

  /** 将当前实例置入到全局的低码环境中 */;
  _proto.initLowcode = function initLowcode() {
    window.$i18n_lowcode = this;
  }

  /** 将该实例锁定为OS环境的语种，如不在os环境中则不会生效 */;
  _proto.lockOSLang = function lockOSLang() {
    var osLang = getOSLang();
    if (osLang) {
      this.setCustomLang(osLang);
    }
  }

  /** 设置一个标记位，标识该实例，开发专用!!! */;
  _proto.__setType = function __setType(type) {
    this.type = type;
  }

  /** 初始化组件包实例（将初始化多个实例） */;
  _proto.initPackage = function initPackage(_ref) {
    var _this3 = this;
    var name = _ref.name,
      locales = _ref.locales;
    // this.packageName = name;
    if (locales) {
      var componentMap = {};
      Object.values(locales).forEach(function (locale) {
        Object.keys(locale).forEach(function (ns) {
          if (typeof locale[ns] === 'string') {
            error('no support locales type');
          } else if (!componentMap[ns]) {
            componentMap[ns] = _this3.init({
              componentName: ns,
              locale: locales,
              packageName: name
            });
          }
        });
      });
    }
  };
  return I18n;
}(); // _init 标记为默认的$i18n实例（cdn）
var defaultI18n = new I18n();
export var init = function init(params) {
  return defaultI18n.init(params);
};
export { I18n };
export default defaultI18n;